import { FormControl, ValidationErrors } from '@angular/forms';

export function urlValidator(control: FormControl): ValidationErrors | null {
  // Regular expression for URL validation
  const URL_REGEXP = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-\_]+\.[a-zA-Z]{2,5}[\.]{0,1}/;

  if (control.value === null || control.value === '') {
    return null; // consider empty value as valid
  }

  return URL_REGEXP.test(control.value) ? null : { invalidUrl: true };
}
